<template>
  <component v-bind:is="loadLayout"></component>
</template>

<script>
import DesktopLayout from "./layouts/DesktopLayout.vue";
export default {
  beforeMount: function() {
    let data = {};

    data.cur = this.$cookie.get("selectedCurrency")
      ? this.$cookie.get("selectedCurrency")
      : "SAR";
  },
  computed: {
    loadLayout() {
      return this.$store.getters.getLayout;
    }
  },
  components: {
    "desktop-layout": DesktopLayout
  }
};
</script>



// WEBPACK FOOTER //
// App.vue